module.exports = __webpack_public_path__ + "static/media/01.870c02b5.png";